import { useEffect, useState } from 'react';
import { fetchCommonLinkImageUrl } from '@/services/commonLinks.service';
import { useAuthStore } from '@/store/authStore';

/** One fetch per account and file, shared by every tile and row that shows it. */
const cache = new Map<string, Promise<string | null>>();

/**
 * A Common Link's image as an object URL. `entryImage` is a bare file name in
 * the account's dashboard folder (where legacy's dashboard reads it), so an
 * <img> cannot point at it; the image comes through the API instead, as tag
 * icons do (useTagIcon). Undefined while loading or when there is none.
 */
export function useCommonLinkImage(fileName: string | null | undefined): string | undefined {
  const accountId = useAuthStore((s) => s.accountId);
  const name = (fileName ?? '').trim();
  const [url, setUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    setUrl(undefined);
    if (name === '') return;
    const key = `${accountId ?? ''}:${name}`;
    let request = cache.get(key);
    if (!request) {
      request = fetchCommonLinkImageUrl(0, name).catch(() => null);
      cache.set(key, request);
    }
    let cancelled = false;
    void request.then((u) => {
      if (!cancelled) setUrl(u ?? undefined);
    });
    return () => {
      cancelled = true;
    };
  }, [accountId, name]);

  return url;
}
